import * as THREE from 'three';
import type { Terrain } from '../terrain/Terrain';
import type { SurfaceProperties } from './SurfaceProperties';
import { getSurfaceProperties } from './SurfaceProperties';

export interface SurfaceSample {
  readonly height: number;
  readonly normal: THREE.Vector3;
  readonly slopeRadians: number;
  readonly properties: SurfaceProperties;
}

/** Stable simulation-facing terrain query layer. If Terrain becomes tiled/LOD/editor-backed later, this class's callers do not change. */
export class TerrainSurfaceProbe {
  constructor(private readonly terrain: Terrain) {}

  sample(x: number, z: number): SurfaceSample {
    const normal = this.terrain.getNormalAt(x, z).normalize();
    const surfaceType = this.terrain.getSurfaceTypeAt(x, z);
    const upDot = THREE.MathUtils.clamp(normal.dot(new THREE.Vector3(0, 1, 0)), -1, 1);
    return {
      height: this.terrain.getHeightAt(x, z),
      normal,
      slopeRadians: Math.acos(upDot),
      properties: getSurfaceProperties(surfaceType),
    };
  }
}
